import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'



import BoxButton from '../Layout/BoxButton'
import BoxSection from '../Layout/BoxSection'
import ModalAddFile from '../Shared/ModalAddFile'
import ModalAddReservacion from './ModalAddReservacion'


import { 
    displayModalAddReservacion, 
    addFile,
} from '../../actions/solicitudhoteles'


import { 
    displayModalAddFile, 
    downloadFile
} from '../../actions/common'


import { isAllowedToViewComponent } from '../../utils/helpers'


class Reservaciones extends Component {

	render() {
        
        const { id, solicitudhoteles } = this.props
        if (!id) return null
        
        return ( 
        <Fragment>

            <BoxSection title="Registro de reservaciones">

                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-reservaciones">                                    
                    <thead>
                        <tr>
                            <th style={{ width: '30px' }}></th>
                            <th style={{ width: '6%', textAlign: 'center' }}>No.Huesp.</th>
                            <th>No. Reservación</th>
                            <th style={{ width: '8%' }}>Valor</th>
                            <th>Fecha compra</th>
                            <th style={{ width: '10%' }}>Proveedor</th>
                            <th style={{ width: '40%' }}>Alojamiento</th>
                            {
                                solicitudhoteles.get('estado') == 4 ? <th>Adjuntar reservación</th> : <th>Descargar reservaciónn</th>
                            }
                            
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (solicitudhoteles.getIn(['hotel', 'huespedes']).count() > 0) &&
                                solicitudhoteles.getIn(['hotel', 'huespedes']).map((x, n) => {

                                    const fileid = x.getIn(['reservacion', 'adjunto']) ? x.getIn(['reservacion', 'adjunto', 'id']) : null
                                    const filename = x.getIn(['reservacion','adjunto', 'nombre']) ? x.getIn(['reservacion', 'adjunto', 'nombre']) : null

                                    return (                                        
                                        <tr key={ `tr[${n}]`}>
                                            <td style={{ textAlign: 'center' }}><BoxButton size={ 12 } name="pencil" onClick={ () => this.props.displayModalAddReservacion(true, 'Agregar reservación', n) } disabled={ solicitudhoteles.get('estado')!=4 || !isAllowedToViewComponent('responsable_compras', solicitudhoteles) }/></td>
                                            <td className="text-right">{n+1}</td>
                                            <td>{x.getIn(['reservacion', 'numero_reservacion'])}</td>
                                            <td className="text-right">{numeral(x.getIn(['reservacion', 'valor_pagado'])).format('$0,0.00')}</td>
                                            <td>{x.getIn(['reservacion', 'fecha_compra']) ? moment(x.getIn(['reservacion', 'fecha_compra'])).format('DD/MM/YYYY') : '' }</td>
                                            <td>{x.getIn(['reservacion', 'proveedor_alojamiento'])}</td>  

                                            <td>
                                                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">
                                                    <thead>
                                                        <tr>
                                                            <th>Ciudad</th>
                                                            <th>Fecha ingreso</th>
                                                            <th>Fecha salida</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            x.getIn(['reservacion', 'rutas']).map((t,ti) => {
                                                                return(
                                                                    <tr key={`ite[${n}][${ti}]`}>
                                                                        <td>{t.get('ciudad')}</td>
                                                                        <td>{ moment(t.get('fecha_ingreso')).format('DD/MM/YYYY') }</td>
                                                                        <td>{ moment(t.get('fecha_salida')).format('DD/MM/YYYY') }</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>                                                
                                                </table>                                                
                                            </td>  

                                            {
                                                solicitudhoteles.get('estado') == 4 ? (
                                                    <td>
                                                        {x.getIn(['reservacion', 'adjunto']) ? `${x.getIn(['reservacion', 'adjunto', 'nombre'])}` : 'Archivo sin adjuntar'}
                                                    </td>
                                                ) : (
                                                    <td style={{ cursor: 'pointer' }} onClick={ (x.getIn(['reservacion', 'adjunto'])) ? () => this.props.downloadFile(fileid, filename) : () => null }>
                                                        <i className="fa fa-download"></i>
                                                        <span style={{ marginLeft: '3px' }}>{`${x.getIn(['reservacion', 'adjunto', 'nombre'])}`}</span>                                                        
                                                    </td>
                                                )
                                            }
                                        </tr>
                                    )                                    
                                })
                        }
                    </tbody>
                </table>
            
            </BoxSection>

            <ModalAddReservacion displayModalAddFile={ this.props.displayModalAddFile }/>

            <ModalAddFile
                action={ () => this.props.addFile('modalAddReservacion.data.reservacion.adjunto') }
            />


        </Fragment> 
        )
	}
}

function mapStateToProps(state) {
    return {
        id: state.solicitudhoteles.get('id'),
        solicitudhoteles: state.solicitudhoteles.get('solicitud')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        displayModalAddReservacion: (show, title, index) => dispatch(displayModalAddReservacion(show, title, index)), 
        displayModalAddFile: (show, title, mode, index) => dispatch(displayModalAddFile(show, title, mode, index)),
        addFile: (path) => dispatch(addFile(path)), 
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reservaciones)


// WEBPACK FOOTER //
// ./src/components/SolicitudHoteles/Reservaciones.jsx